module.exports = __webpack_public_path__ + "static/media/blog_grid_4.d94e7cf0.jpg";